import React from 'react';
import { Typography } from '@saddlebackchurch/react-cm-ui';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BEM_BLOCK_NAME } from './constants';

const useStyles = makeStyles(({
    typography,
}) => ({
    title: {
        fontWeight: typography.fontWeightBold,
    },
}));

const CLASS_NAME_COMMITMENT_TITLE: string = `${BEM_BLOCK_NAME}--setup_commitment_title`;

type PropTypes = {
    /** Translation key for the heading; the signed-out card passes the "Review My Commitment" variant */
    textKey?: string;
};

function CommitmentTitle({ textKey = 'common.infoContainer.title' }: PropTypes) {
    const classes = useStyles();

    const { t } = useTranslation();

    const titleClassNames = ClassNames(classes.title, CLASS_NAME_COMMITMENT_TITLE);

    return (
        <Typography
            className={titleClassNames}
            component="div"
            variant="body1"
        >
            {t(textKey)}
        </Typography>
    );
}

export default CommitmentTitle;
